var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14515_1520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.28476 7.90625L0.752621 20.3442C0.37524 21.6751 1.3681 23 2.7431 23C3.65738 23 4.46333 22.3963 4.72643 21.5146L8.56929 8.625L4.28357 7.90625H4.28476Z",
    fill: "#2567D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14342 12.9375L21.4291 17.25H22.1434V1.4375H21.4291L7.14342 5.75H5.71484V12.9375H7.14342Z",
    fill: "#B0D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85714 5.75H7.14286V12.9375H2.85714C1.27976 12.9375 0 11.6497 0 10.0625V8.625C0 7.03776 1.27976 5.75 2.85714 5.75Z",
    fill: "#2B8BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 1.4375V0.71875C21.4297 0.32224 21.7499 0 22.144 0H23.5725C23.9666 0 24.2868 0.32224 24.2868 0.71875V17.9688C24.2868 18.3653 23.9666 18.6875 23.5725 18.6875H22.144C21.7499 18.6875 21.4297 18.3653 21.4297 17.9688V1.4375Z",
    fill: "#2B9AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2863 10.0625H26.4291C26.0351 10.0625 25.7148 9.74026 25.7148 9.34375C25.7148 8.94724 26.0351 8.625 26.4291 8.625H29.2863C29.6803 8.625 30.0006 8.94724 30.0006 9.34375C30.0006 9.74026 29.6803 10.0625 29.2863 10.0625Z",
    fill: "#66BAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4285 5.75038C26.2452 5.75038 26.0631 5.6797 25.9238 5.53954C25.6452 5.25923 25.6452 4.80402 25.9238 4.52371L28.7809 1.64871C29.0595 1.3684 29.5119 1.3684 29.7904 1.64871C30.069 1.92902 30.069 2.38423 29.7904 2.66454L26.9333 5.53954C26.794 5.6797 26.6107 5.75038 26.4285 5.75038Z",
    fill: "#66BAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2857 17.2504C29.1023 17.2504 28.9202 17.1797 28.7809 17.0395L25.9238 14.1645C25.6452 13.8842 25.6452 13.429 25.9238 13.1487C26.2023 12.8684 26.6547 12.8684 26.9333 13.1487L29.7904 16.0237C30.069 16.304 30.069 16.7592 29.7904 17.0395C29.6512 17.1797 29.4678 17.2504 29.2857 17.2504Z",
    fill: "#66BAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14515_1520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.c91dd2e22814e1b3111b4f3d4921ff64.svg";
export { ForwardRef as ReactComponent };